import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=02069bf3&scoped=true"
import script from "./AuthDialog.vue?vue&type=script&lang=js"
export * from "./AuthDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02069bf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02069bf3')) {
      api.createRecord('02069bf3', component.options)
    } else {
      api.reload('02069bf3', component.options)
    }
    module.hot.accept("./AuthDialog.vue?vue&type=template&id=02069bf3&scoped=true", function () {
      api.rerender('02069bf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/org/components/orgGroup/AuthDialog.vue"
export default component.exports